import type { IconProps } from '../types/IconProps.ts';
export const Terminal: IconProps = {
    name: 'Terminal',
    children: [
        `<path d="m4 5 5.86 5.86a.2.2 0 0 1 0 .28L4 17M12 19h8" />`,
    ]
};